import { render, staticRenderFns } from "./ChartProjectionComparison.vue?vue&type=template&id=4cfeafe3&lang=pug&"
import script from "./ChartProjectionComparison.vue?vue&type=script&lang=js&"
export * from "./ChartProjectionComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
